import { render, staticRenderFns } from "./sociales.vue?vue&type=template&id=3c1e9cfa&scoped=true"
import script from "./sociales.vue?vue&type=script&lang=js"
export * from "./sociales.vue?vue&type=script&lang=js"
import style0 from "./sociales.vue?vue&type=style&index=0&id=3c1e9cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e9cfa",
  null
  
)

export default component.exports